module.exports = __webpack_public_path__ + "media/blink-final.700dbb3c.mp4";